<template>
  <div class="title" style="margin: 40px 0; align: center; z-index: 1">
    <b-row>
      
      <b-col cols="12" >
          <div class="num">{{number}}.</div>
          <h2 style="width: calc(100% - 76px); float: left; margin-left:-3px" >{{ title }}</h2>
      </b-col>
    </b-row>
  </div>
</template>


<script>
export default {
  name: "Title",
  props: {
    number: Number,
    title: String
  }
};
</script>


<style>
.num {
  padding: 12px;
  text-align: center;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 33px;
  color: #2c2c2c;
  position: relative;
  margin-right: 27px;
  background-image: url(../assets/z.svg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: #3d3d3d;
  line-height: 1;
  float: left;
}
.title h2 {
  padding-top: 12px;
  display: table; 
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 33px;
  line-height: 44px;
  color: #3d3d3d;
  margin-left: -25px;
   line-height: 1;

}
/* @media only screen and (min-width: 600px) and (max-width: 900px){
        .title h2
        {
            font-size: 100px;

        }
    } */
</style>